import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'
import { SEOHead } from '@/components/SEOHead'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <>
      <SEOHead titleKey="error.title" titleSuffix />

      <section className="section-padding flex items-center justify-center min-h-[60vh]">
        <div className="container-main text-center">
          <p className="text-6xl font-bold text-accent mb-4">404</p>
          <h1 className="text-2xl md:text-3xl font-bold mb-4">{t('error.title')}</h1>
          <p className="text-text-muted mb-8 max-w-md mx-auto">{t('error.description')}</p>
          <LocalizedLink to="home" className="btn-primary">
            {t('buttons.backToHome')}
          </LocalizedLink>
        </div>
      </section>
    </>
  )
}
